import React from "react";

import { toast } from "@performyard/py-components";

import { useAiSettings, useUpdateAiSettings } from "../../../../../api/hooks";

import { SectionLayout, SettingsToggle } from "../../../Components";

const AIInsightsEngagementSettingsTab = () => {
	// AI settings data management
	const { mutateAsync: updateAiSettings } = useUpdateAiSettings();
	const { data, isLoading } = useAiSettings();

	// toggles
	const isTextResponseSummarizationEnabled = data?.engagementAnalysisEnabled ?? true;
	const isCohortInsightsEnabled = data?.engagementCohortInsightsEnabled ?? true;

	// toggle handlers
	const handleTextResponseSummarizationToggle = async (val: boolean) => {
		await updateAiSettings({ engagementAnalysisEnabled: val });
		toast.success(`Text Response Summarization ${val === true ? "Enabled" : "Disabled"}.`);
	};

	const handleCohortInsightsToggle = async (val: boolean) => {
		await updateAiSettings({ engagementCohortInsightsEnabled: val });
		toast.success(`Cohort Insights ${val === true ? "Enabled" : "Disabled"}.`);
	};

	if (isLoading) {
		return null;
	}

	return (
		<SectionLayout
			key="engagement-settings-section"
			title="Engagement Insights"
			description="Text response summarization allows admins to receive a report containing a summary and analysis of responses to text questions in a pulse survey."
		>
			<SettingsToggle
				key="text-response-summarization-toggle"
				id="enable-text-response-summarization"
				label="Enable Text Response Summarization"
				description="Disabling this setting will hide the ability to summarize text responses in Engagement."
				checked={isTextResponseSummarizationEnabled}
				onCheckedChange={handleTextResponseSummarizationToggle}
				dataTestId="text-response-summarization-toggle"
			/>

			<SettingsToggle
				key="cohort-insights-toggle"
				id="enable-cohort-insights"
				label="Enable Cohort Insights"
				description="Disabling this setting will hide the ability to analyze cohort satisfaction scores on the Cohorts dashboard page."
				checked={isCohortInsightsEnabled}
				onCheckedChange={handleCohortInsightsToggle}
				dataTestId="cohort-insights-toggle"
			/>
		</SectionLayout>
	);
};

export default AIInsightsEngagementSettingsTab;
